import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import FileIcon from "../../../../../../../../assets/icons/FileIcon";
import FileTextIcon from "../../../../../../../../assets/icons/FileTextIcon";
import FileSpreadSheetIcon from "../../../../../../../../assets/icons/FileSpreadSheetIcon";
import FileImageIcon from "../../../../../../../../assets/icons/FileImageIcon";
import FilePlayIcon from "../../../../../../../../assets/icons/FilePlayIcon";
import FileArchiveIcon from "../../../../../../../../assets/icons/FileArchiveIcon";
import colors from "../../../../../../../../utils/Colors";

const extensionIcons = {
    'pdf': FileTextIcon,
    'doc': FileTextIcon,
    'docx': FileTextIcon,
    'xls': FileSpreadSheetIcon,
    'xlsx': FileSpreadSheetIcon,
    'png': FileImageIcon,
    'jpg': FileImageIcon,
    'jpeg': FileImageIcon,
    'webp': FileImageIcon,
    'gif': FileImageIcon,
    'mp4': FilePlayIcon,
    'mp3': FilePlayIcon,
    'zip': FileArchiveIcon,
    'rar': FileArchiveIcon,
    'txt': FileTextIcon,
    'default': FileIcon
};

const getFileExtension = (filename = '') => {
    const match = filename.match(/\.([a-zA-Z0-9]+)(?:\?|#|$)/);
    return match ? match[1].toLowerCase() : 'default';
};

const Attachment = ({ link, fileName }) => {
    const ext = useMemo(() => getFileExtension(fileName || link), [fileName, link]);
    const Icon = extensionIcons[ext] || extensionIcons['default'];

    return (
        <Icon style={{color: colors.silverBlue}} stroke="currentColor" width={16} height={16}/>
    );
};

Attachment.propTypes = {
    link: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    onDelete: PropTypes.func
};

export default Attachment;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/components/Node/Attachment.jsx